import React, { useState } from 'react';

type EllipsProps = {
  label?: string;
  word: string;
  NoOfChar: number;
};

const EllipsisHanlder = (props: EllipsProps) => {
  const { label, word, NoOfChar } = props;
  const [isHovered, setIsHovered] = useState(false);

  const dataHandler = (word: string) => {
    if (word == undefined) {
      return <div>-</div>;
    } else {
      return (
        <div>
          {word?.length < NoOfChar ? (
            <div>{word}</div>
          ) : (
            <div className="cursor-pointer">
              {word?.substring(0, NoOfChar) + '...'}
            </div>
          )}
        </div>
      );
    }
  };
  return (
    <div className="w-full" onMouseLeave={() => setIsHovered(false)}>
      <div>
        <div className="flex items-center" onMouseOver={() => setIsHovered(true)}>
          {' '}
          <div className="font-semibold">{label} :&nbsp;</div>{' '}
          <div>{dataHandler(word)}</div>
        </div>
        {isHovered && word?.length > NoOfChar && (
          <div className="max-w-[500px] absolute  bg-blue-950 text-white text-sm rounded-md p-2 z-50 opacity-80 transition-all duration-200 ease-in-out">
            {word}
          </div>
        )}
      </div>
    </div>
  );
};

export default EllipsisHanlder;
